import { ListContainer } from 'components';
import InviteUser from 'containers/servicer-users/InviteUser';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { texts } from 'utils/languages/fr';
import DistributorUsersTable from './DistributorUsersTable';

const DistributorUsers = () => {
    return (
        <ListContainer>
            <Routes>
                <Route
                    path="invite"
                    element={<InviteUser title={texts.CREATE_USER} type="cif" />}
                />
                <Route index element={<DistributorUsersTable />} />
                <Route path="*" element={<Navigate to="/distributor-users" replace />} />
            </Routes>
        </ListContainer>
    );
};

export default DistributorUsers;
